export let isIE11 = !(window.ActiveXObject) && 'ActiveXObject' in window;
